"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function resolvePackageKeyFactory() {
  return function (packageJson, packageKeys) {
    var packageKey = packageKeys.find(function (x) {
      return packageJson[x];
    });

    if (packageKey) {
      return Object.assign({}, packageJson, {
        main: packageJson[packageKey]
      });
    }

    return packageJson;
  };
}

exports.resolvePackageKeyFactory = resolvePackageKeyFactory;